<script lang="ts">
  import { createEventDispatcher, type ComponentType } from 'svelte';

  const dispatch = createEventDispatcher<{ clickTab: { tabData: TabData } }>();

  interface TabData<T = string> {
    title: string;
    value?: T;

    /* eslint-disable @typescript-eslint/no-explicit-any */
    icon?: any;
  }

  export let tabs: ReadonlyArray<TabData>;
  export let tabComponent: ComponentType;
  export let selectedTab = tabs[0];
  export let disabled = false;
  export let bottomBorder = false;

  function onClick(tabData: TabData) {
    selectedTab = tabData;
    dispatch('clickTab', { tabData });
  }
</script>

<div class="flex border-b-[#f6f6f7]  gap-2" class:border-b={bottomBorder}>
  {#each tabs as tabData}
    <svelte:component
      this={tabComponent}
      isSelected={selectedTab === tabData}
      {tabData}
      on:click={() => onClick(tabData)}
      {disabled}
    />
  {/each}
</div>
